import React, { useContext, useState } from "react";
import { CartContext } from "./CartContext";
import productData from "../Datas/productData";
import { Link } from "react-router-dom";
import ReactFlagsSelect from "react-flags-select";
import "../css/checkout.css";

const SHIPPING = 9.99;
const SANCTIONED_COUNTRIES = ["BY", "CU", "IR", "KP", "RU", "SY"];

const CheckOut = () => {
  const { cartItems } = useContext(CartContext);
  const [form, setForm] = useState({ email: "", firstName: "", lastName: "", company: "", address: "", address1: "", city: "", postalCode: "" });
  const [countryCode, setCountryCode] = useState("");

  const getProductById = (id) => productData.find((product) => product.id === id);
  const subtotal = cartItems.reduce((total, item) => {
    const product = getProductById(item.id);
    return product ? total + Number(product.price) * item.quantity : total;
  }, 0);
  const total = subtotal + SHIPPING;

  const update = (event) => setForm((current) => ({ ...current, [event.target.name]: event.target.value }));
  const handlePlaceOrder = () => {
    const required = ["email", "firstName", "lastName", "address", "city", "postalCode"];
    if (!cartItems.length || !countryCode || required.some((field) => !form[field].trim()) || !/^\S+@\S+\.\S+$/.test(form.email)) {
      alert("Please complete all required delivery fields with a valid email address.");
      return;
    }

    const firstProduct = getProductById(cartItems[0].id);
    const orderNo = `${Date.now()}${Math.floor(100000 + Math.random() * 900000)}`;
    const origin = window.location.origin;
    const params = new URLSearchParams({
      orderNo,
      amount: total.toFixed(2),
      currency: "USD",
      email: form.email.trim(),
      success_url: `${origin}/payment?state=success`,
      cancel_url: `${origin}/payment?state=cancel`,
      title: firstProduct?.name || "pmistpearl order",
    });
    window.location.assign(`${origin}/create_payment.php?${params.toString()}`);
  };

  return (
    <main className="main-containerCheck">
      <header className="checkout-intro">
        <p>pmistpearl · Secure checkout</p>
        <h1>Complete your order</h1>
      </header>
      <div className="check-custom-checkout-page">
        <div className="left"><div className="check-order-info">
          <form onSubmit={(event) => event.preventDefault()}>
            <div className="form-group"><label>Contact</label><input type="email" name="email" value={form.email} placeholder="Email address" onChange={update} required /></div>
            <div className="form-group"><label>Delivery</label><ReactFlagsSelect selected={countryCode} onSelect={setCountryCode} blacklistCountries={SANCTIONED_COUNTRIES} className="check-select" /></div>
            <div className="form-row">
              <div className="form-group"><input type="text" name="firstName" value={form.firstName} placeholder="First name *" onChange={update} required /></div>
              <div className="form-group"><input type="text" name="lastName" value={form.lastName} placeholder="Last name *" onChange={update} required /></div>
            </div>
            <div className="form-group"><input type="text" name="company" value={form.company} placeholder="Company name (optional)" onChange={update} /></div>
            <div className="form-group"><input type="text" name="address" value={form.address} placeholder="Address *" onChange={update} required /></div>
            <div className="form-group"><input type="text" name="address1" value={form.address1} placeholder="Apartment, suite, etc. (optional)" onChange={update} /></div>
            <div className="form-row">
              <div className="form-group"><input type="text" name="city" value={form.city} placeholder="City *" onChange={update} required /></div>
              <div className="form-group"><input type="text" name="postalCode" value={form.postalCode} placeholder="Postal code *" onChange={update} required /></div>
            </div>
            <div className="form-group"><label>Shipping method</label><div className="shipping-method"><span>Standard tracked shipping</span><strong>${SHIPPING.toFixed(2)}</strong></div></div>
          </form>
          <button className="check-checkout-button" onClick={handlePlaceOrder}>Pay Now</button>
          <p><Link to="/returns" style={{ textDecoration: "underline" }}>Shipping &amp; Returns Info</Link></p>
        </div></div>

        <div className="right"><div className="check-order-summary"><div className="check-order-details">
          {cartItems.map((item, index) => {
            const product = getProductById(item.id);
            if (!product) return null;
            return <div key={`${item.id}-${index}`} className="check-cart-item"><img src={product.image} alt={product.name} /><div className="pro--qty"><div className="qty-inner">{item.quantity}</div></div><div className="check-item-details"><h3>{product.name}<br />{item.color}</h3></div><p className="cal-single">${(Number(product.price) * item.quantity).toFixed(2)}</p></div>;
          })}
          <div className="check-summary-details">
            <div className="summary-line"><span>Subtotal</span><span>${subtotal.toFixed(2)}</span></div>
            <div className="summary-line"><span>Tracked shipping</span><span>${SHIPPING.toFixed(2)}</span></div>
            <div className="summary-line summary-total"><span>Total</span><span>${total.toFixed(2)} <small>USD</small></span></div>
          </div>
        </div></div></div>
      </div>
    </main>
  );
};

export default CheckOut;
